module.exports = __webpack_public_path__ + "static/media/PullUpsFemale.37cc7634.svg";